import Vue from 'vue'

import uiTabItem from './src/ui-tab-item.vue';
import uiTabs from './src/ui-tabs.vue';

var components = [
  uiTabItem,
  uiTabs
];

components.forEach(function(component) {
  Vue.component(component.extendOptions.name, component);
})

export default components;



//////////////////
// WEBPACK FOOTER
// ./~/ui-tabs/index.js
// module id = 559
// module chunks = 0